import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {Fragment} from 'react/jsx-runtime'
import {MainReducer, RootState, UserReducer} from 'setup'

import {getAsideMenuLinks} from './SidebarLinks'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'

const SidebarMenuMain = () => {
  const intl = useIntl()

  const mainReducer = useSelector<RootState>((rootState) => rootState.mainReducer) as MainReducer
  const userReducer = useSelector<RootState>((rootState) => rootState.userReducer) as UserReducer

  const AsideMenuLinks = getAsideMenuLinks({
    mainReducer,
    userReducer,
  })

  return (
    <>
      {AsideMenuLinks.map((menuLink, i) => (
        <Fragment key={i}>
          {menuLink.type === 'separator' ? (
            <div
              className={clsx('menu-item', {'d-none': !menuLink.visible})}
              key={`${i}-separator`}
            >
              <div className='menu-content py-2'>
                <div className='separator' />
              </div>
            </div>
          ) : menuLink.type === 'label' ? (
            <div
              className={clsx('menu-item', {'d-none': !menuLink.visible})}
              key={`${i}-${menuLink.to || menuLink.title}`}
            >
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                  {intl.formatMessage({id: menuLink.title})}
                </span>
              </div>
            </div>
          ) : menuLink.subLinks ? (
            <SidebarMenuItemWithSub {...menuLink} key={`${i}-${menuLink.to || menuLink.title}`} />
          ) : (
            <SidebarMenuItem
              to={menuLink.to}
              title={menuLink.title}
              icon={menuLink.icon}
              fontIcon={menuLink.fontIcon}
              hasBullet={menuLink.hasBullet ?? false}
              visible={menuLink.visible}
              target={menuLink.target}
              external={menuLink.external}
              key={`${i}-${menuLink.to || menuLink.title}`}
            />
          )}
        </Fragment>
      ))}
    </>
  )
}

export {SidebarMenuMain}
